import {
    AnnotationIcon,
    GlobeAltIcon,
    LightningBoltIcon,
    MailIcon,
    ScaleIcon
} from '@heroicons/react/outline'

import scoutEmUp from "../../assets/scout-em-up.png"
import deliveringDataToYourHands from "../../assets/delivering-data-to-your-hands.png"

const transferFeatures = [
    {
        id: 1,
        name: 'Make data-driven decisions',
        description:
            'Data-driven decisions are more important than ever in the esports industry. By analyzing data, teams and organizations can make better decisions about everything from strategic improvements to roster adjustments.',
        icon: GlobeAltIcon,
    },
    {
        id: 2,
        name: 'Create competitive advantage',
        description:
            'Study the statistics of players to understand their strengths and weaknesses better. Data is here to take your game to the next level and create a competitive advantage over your opponents.',
        icon: ScaleIcon,
    },
    {
        id: 3,
        name: 'Low cost',
        description:
            'If you\'re looking for an easy way to access esports data, consider using a low-cost solution like ours. Our platform is designed to save you time and make it easy to find the data you need.',
        icon: LightningBoltIcon,
    },
]
const communicationFeatures = [
    {
        id: 1,
        name: 'Find high potential players all around the world',
        description:
            'Featuring the best high potential esports players, we provide all the information you need to scout the talent of tomorrow. With our constantly updating player database, look no further.',
        icon: AnnotationIcon,
    },
    {
        id: 2,
        name: 'Track every statistics',
        description:
            'We make it easy for you to get all the data you need to make informed decisions about your team and players. Every inch of esports data in one place.',
        icon: MailIcon,
    },
]

const Introduction = () => {
    return (
        <div className="py-16 overflow-hidden lg:24">
            <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
                <div className="relative">
                    <h2 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                        The Next Generation Esports Analytics
                    </h2>

                    <p className="mt-4 max-w-3xl mx-auto text-center text-xl text-gray-500">
                        Increase your chances for winning, use historical and real time data in the most important matches. See what your team is missing.
                    </p>
                </div>

                <div className="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
                    <div className="relative">
                        <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight text-center md:text-left sm:text-3xl">
                            Delivering data to your hands
                        </h3>

                        <p className="mt-3 text-lg text-gray-500 text-center md:text-left">
                            For many esports organizations, data-driven decision-making is still an elusive goal, and the concept is rarely universal.
                        </p>

                        <dl className="mt-10 space-y-10">
                            {transferFeatures.map((item) => (
                                <div key={item.id} className="relative">
                                    <dt>
                                        <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                                            <item.icon className="h-6 w-6" aria-hidden="true" />
                                        </div>

                                        <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{item.name}</p>
                                    </dt>

                                    <dd className="mt-2 ml-16 text-base text-gray-500">{item.description}</dd>
                                </div>
                            ))}
                        </dl>
                    </div>

                    <div className="mt-10 -mx-4 relative lg:mt-0" aria-hidden="true">
                        <img
                            className="relative mx-auto"
                            width={490}
                            src={deliveringDataToYourHands}
                            alt="Delivering data to your hands"
                        />
                    </div>
                </div>

                <div className="relative mt-12 sm:mt-16 lg:mt-24">
                    <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
                        <div className="lg:col-start-2">
                            <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl text-center md:text-left">Scout ‘em up!</h3>

                            <p className="mt-3 text-lg text-gray-500 text-center md:text-left">
                                Finding the next big star in esports can be difficult. Teams often skip this step and go with popular, successful players instead.
                            </p>

                            <dl className="mt-10 space-y-10">
                                {communicationFeatures.map((item) => (
                                    <div key={item.id} className="relative">
                                        <dt>
                                            <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                                                <item.icon className="h-6 w-6" aria-hidden="true" />
                                            </div>

                                            <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{item.name}</p>
                                        </dt>

                                        <dd className="mt-2 ml-16 text-base text-gray-500">{item.description}</dd>
                                    </div>
                                ))}
                            </dl>
                        </div>

                        <div className="mt-10 -mx-4 relative lg:mt-0 lg:col-start-1">
                            <img src={scoutEmUp} alt="Scout 'em up!"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Introduction;
